import { connect } from 'react-redux';
import {
  getActs,
  signActs
} from '../../../store/actions/adminActs';
import { resetMessages } from '../../../store/actions/adminMessages';
import ActsAdmin from './ActsAdmin';

const mapStateToProps = ({
  adminActsReducer,
  adminMessagesReducer
}) => ({
  adminActsReducer,
  adminMessagesReducer
});
const mapDispatchToProps = {
  getActs,
  signActs,
  resetMessages
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActsAdmin);
